/**
 * import node_modules
 */
// import 'desvg';
// import SmoothScroll from 'smooth-scroll';

/*YOUTUBE等の遅延読み込み
  【仕様】
 * YOUTUBE等の埋め込みタグ使用時に設定。
 * js-delaySrcというクラスが付いた要素が画面内に入った時点で、
 * data-src属性の内容をsrc属性に設定することで読み込みを開始します。
 * 不要の場合はnew DelaySrc();をコメントアウトする。
 */
import DelaySrc from './modules/delay_src';

/*アコーディオン
  【仕様】
 * js-accordion-triggerというクラスが付いた要素がクリックされたときに、
 * クリックした要素に is-open というクラスを付与/削除、
 * 直後の隣接する兄弟要素を表示/非表示します。
 *
 * slideToggleしたいがクリック要素に隣接していなかった場合、
 * js-accordion-trigger クラスが付いた要素にdata-target="●●●"を付けて、
 * アコーディオンしたい要素に.js-●●●を付けるとjs-●●●を付けた要素がslideToggleする。
 *
 * 不要の場合はnew Accordion();をコメントアウトする。
 */
import Accordion from './modules/accordion';


/**
 * import modules
 */
import Common from './modules/common';
import Tab from './modules/tab';
import Dialog from './modules/dialog';

/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();

  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();
    });
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    new Common();
    new DelaySrc();
    if (window.matchMedia('(max-width: 767px)').matches) {
      new Accordion({
        triggerClassName: '.js-accordion-trigger-sp',
      });
    }
    new Tab();
    new Dialog();
  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {
    // this.init_deSVG('.js-desvg');
    // this.init_smoothScroll();
  }

  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  // init_deSVG(target) {
  //   deSVG(target, true);
  // }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  // init_smoothScroll() {
  //   /**
  //    * ターゲットとなる要素
  //    * @type {Element}
  //    */
  //   const targetElement = 'a[href*="#"]';

  //   /**
  //    * オプション
  //    * @type {object}
  //    */
  //   const option = {
  //     speed: 1000,
  //     easing: 'easeInOutCubic',
  //     speedAsDuration: true,
  //     //header: '.l-header' 固定ヘッダーの場合
  //   };

  //   new SmoothScroll(targetElement, option);
  // }
}

export default new Main();
